module.exports = __webpack_public_path__ + "static/media/account.5467e4e2.svg";